<template>
    <div class="quote">
<!--        <el-card>-->
<!--            <el-page-header v-if="from == 'rfq'" @back="goBack" content="报价单管理"></el-page-header>-->
<!--            <el-breadcrumb v-if="from == 'menu'" separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>报价单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>报价录入</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>

                 <el-table stripe
                    size="mini"
                    :data="tableData"
                    ref="detailTable"
                    v-loading="loading"
                    style="width: 100%">

                    <el-table-column
                        prop="rfqId"
                        label="询报价单编码"
                        >
                    </el-table-column>

                    <el-table-column
                        prop="itemId"
                        label="商品编码"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="itemName"
                        label="商品名称"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="itemUnit"
                        label="商品单位"
                        >
                    </el-table-column>
                     <el-table-column
                             prop="itemNum"
                             label="商品数量"
                     >
                     </el-table-column>
                    <el-table-column v-if="$store.state.userInfo.review"
                        prop="itemPrice"
                        label="商品原单价(元)">
                    </el-table-column>
                    <el-table-column v-if="$store.state.userInfo.review"
                        prop="itemTotalPrice"
                        label="商品原总价(元)">
                    </el-table-column>
                     <el-table-column
                             prop="supplierPrice"
                             label="供应商报价单价(元)">
                     </el-table-column>
                     <el-table-column
                             prop="supplierTotalPrice"
                             label="供应商总报价(元)">
                     </el-table-column>
                    <el-table-column
                        prop="price"
                        label="商品报价单价(元)">
                    </el-table-column>
                    <el-table-column
                        prop="totalPrice"
                        label="商品总报价(元)">
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        label="备注">
                    </el-table-column>
                    <el-table-column label="操作" width="350" align="right">
                        <template slot="header">

                            <el-button type="primary"   size="mini" @click="onSubmitPrice">提交审核</el-button>

                        </template>
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">设置利润</el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="利润率" :visible.sync="editDialogVisible" :before-close="handleClose" width="500px" close-on-click-modal>
            <el-form :model="editForm" label-width="80px">
                <el-form-item label="商品编码">
                    <el-input v-model="editForm.itemId" :disabled="true" placeholder="请输入商品编码" clearable></el-input>
                </el-form-item>

                <el-form-item label="利润率">
<!--                    <el-input v-model="editForm.profitRate"   placeholder="请输入利润率" clearable></el-input>-->

                    <el-input-number
                            v-model="editForm.profitRate"
                            auto-complete="off"
                            :precision="2"
                            placeholder="请输入利润率"
                            :controls="false"
                    ></el-input-number>

                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="商品报价信息导入" :visible.sync="importDialogVisible" width="500px">
            <el-form :model="editForm" label-width="80px">
                <el-form-item label="上传报价文件">
                    <el-upload
                            action="/api/admin/uploadFile"
                            accept=".xlsx"
                            :limit="1"
                            :before-upload="beforeUploadFile"
                            :on-change="fileChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList">
                        <el-button size="small" plain>选择文件</el-button>
                        <div slot="tip">只能上传xlsx(Excel2007)文件，且不超过10M</div>
                    </el-upload>
                    <el-input v-model="editForm.filePath" v-show="false" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onUploadSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="派发询价单" :visible.sync="editSupplier" :close-on-click-modal="false" width="500px">
            <el-form ref="editForm" :model="editForm"  label-width="60px">
                <el-form-item label="供应商" prop="sendId">
                    <el-select v-model="editForm.sendId" placeholder="" multiple="multiple" clearable>
                        <el-option v-for="item in staffs" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editSupplier = false">取 消</el-button>
                <el-button type="primary" @click="onSend">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="报单价信息" :visible.sync="editSupplierVisible" :before-close="handleClose" width="500px" close-on-click-modal>
            <el-form :model="editForm" label-width="80px">
                <el-form-item label="商品编码">
                    <el-input v-model="editForm.itemId" :disabled="true" placeholder="请输入商品编码" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="editForm.itemName" :disabled="true"  placeholder="请输入商品名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品规格">
                    <el-input v-model="editForm.itemSpecification" :disabled="true"  placeholder="请输入商品规格" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品单位">
                    <el-input v-model="editForm.itemUnit" :disabled="true"  placeholder="请输入商品单位" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品数量">
                    <el-input v-model="editForm.itemNum" :disabled="true"  placeholder="请输入商品数量" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品原价" v-if="$store.state.userInfo.review">
                    <el-input v-model="editForm.itemPrice" :disabled="true" placeholder="请输入商品价格" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品报价">
                    <el-input v-model="editForm.answerPrice" placeholder="请输入商品报价" clearable></el-input>
                </el-form-item>
                <el-form-item label="失效时间" prop="expireTime">
                    <el-date-picker
                            v-model="editForm.expireTime"
                            type="date"
                            placeholder="报价失效时间" value-format="yyyy-MM-dd"
                            clearable
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="货期">
                    <el-input v-model="editForm.sendDay" type="number"  placeholder="?日内发货" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="editForm.remark" placeholder="请输入备注" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editSupplierVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            searchForm: {
                itemId: "",
                itemName: "",
                itemPrice: "",
                buyerCode: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            importDialogVisible: false,
            editForm: {
                rfqId: "",
                profitRate: "",//利润率
                id: "",
                userId: null,
                itemId: "",
                itemName: "",
                itemPrice: "",
                answerPrice: "",
                itemSpecification: "",
                itemNum: "",
                itemUnit: "",
                remark: "",
                filePath: "",
                expireTime: "",
                sendDay: "",
            },
            staffs: [],//可选的派发的供应商

            editSupplier: false,
            editSupplierVisible: false,
        }
    },
    props: ["from", "rfqId"],
    methods: {
        onSearch() {
            let url = "/admin/quote/queryPrice";

            this.loading = true;
            let _this = this
            this.$axios.post(url,{rfqId: this.rfqId}

            ).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data
                    _this.total = resp.data.length;
                }
            }).catch(function() {
            });
        },
        handleCreate() {
            this.editForm.rfqId= this.rfqId;
            this.editForm.itemId = "";
            this.editForm.itemPrice = "";
            this.editForm.itemName = "";
            this.editDialogVisible = true;
        },
        handleCreateImport() {
            this.editForm.agreementId= this.agreementId;
            this.importDialogVisible = true;
        },
        onSubmit() {
            let url = "/admin/rfq/rfqdetail/save";
            let postData = {id:this.editForm.id,profitRate:this.editForm.profitRate};

            let _this = this;
            this.$axios.post(url, postData)
            .then(function(response){
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    _this.editDialogVisible = false;
                    _this.editSupplierVisible = false;
                    _this.onSearch();
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        onUploadSubmit() {
            let _this = this;
            this.$axios.post("/admin/rfq/rfqdetail/onUploadSubmit", this.editForm)
            .then(function(response){
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    _this.importDialogVisible = false;
                    _this.onSearch();
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.rfqId = row.rfqId;
            this.editForm.itemId = row.itemId;
            this.editForm.itemName = row.itemName;
            this.editForm.itemNum = row.itemNum;
            this.editForm.itemUnit = row.itemUnit;
            this.editForm.itemPrice = row.itemPrice;
            this.editForm.itemSpecification = row.itemSpecification;
            this.editForm.price = row.price;
            this.editForm.totalPrice = row.totalPrice;
            this.editForm.remark = row.remark;

            if(this.$store.state.userInfo.type == 2) {
                this.editSupplierVisible = true;
            }else{
                this.editDialogVisible = true;
            }
        },

        handleDelete(index, row) {
            let _this = this;
            this.$confirm('是否删除协议价格【' + row.itemId + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/rfq/rfqdetail/delete/" + row.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        _this.onSearch();
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        // 文件状态改变时的钩子
        fileChange(file, fileList) {
            this.editForm.file = file.raw
        },
        // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
        beforeUploadFile(file) {
            let extension = file.name.substring(file.name.lastIndexOf('.')+1)
            let size = file.size / 1024 / 1024
            if(extension !== 'xlsx') {
                this.$notify.warning({
                    title: '警告',
                    message: `只能上传Excel2017（即后缀是.xlsx）的文件`
                });
            }
            if(size > 10) {
                this.$notify.warning({
                    title: '警告',
                    message: `文件大小不得超过10M`
                });
            }
        },
        // 文件上传成功时的钩子
        handleSuccess(res, file, fileList) {
            this.$notify.success({
                title: '成功',
                message: `文件上传成功`
            });
            if (file.response.data.success) {
                this.editForm.filePath = file.response.data.message; //将返回的文件储存路径赋值picture字段
            }
        },
        // 文件上传失败时的钩子
        handleError(err, file, fileList) {
            this.$notify.error({
                title: '错误',
                message: `文件上传失败`
            });
        },
        goBack() {
            this.$router.go(-1);

        },
        onSubmitPrice() {//提交报价
            let arr = this.$refs.detailTable.data;
            for(let i=0; i<arr.length; i++){
                if(arr[i].supplierPrice == null){
                    this.$notify.warning({
                        title: '提示',
                        message: "请先出价"
                    });
                    return;
                }
                if(arr[i].profitRate == null){
                    this.$notify.warning({
                        title: '提示',
                        message: "请先设置利润率"
                    });
                    return;
                }
            }

            let _this = this;
            this.$confirm('是确认提交报价信息给业务经理审核？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.post("/admin/quote/review",{details:arr,rfqId:this.rfqId} )
                    .then(function(response) {
                        let resp = response.data;
                        if(resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '提交成功',
                                type: 'success'
                            });

                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })



        },
        handleClose() {},
        initStaffs() {//加载供应商
            let _this = this;
            this.$axios.post("/admin/rights/staff/list",{type:2})
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.staffs.length = 0;
                        for(let i=0; i<resp.data.length; i++) {
                            let data = resp.data[i];
                            _this.staffs.push({
                                label: data.name,
                                value: data.id,
                            })
                        }

                    }
                })

        },
        onSend() {
            let that = this;
            let rfqDetailList = [];
            let arr = this.$refs.detailTable.selection;//选中的询价单列表
            for(let i=0; i<arr.length; i++){
                rfqDetailList.push(arr[i].id);
            }

            this.$axios.post("/admin/rfq/askSend",{
                rfqId: this.rfqId,
                details: rfqDetailList,//询价单明细id列表
                staffId: this.editForm.sendId,
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    that.$notify({
                        title: '成功',
                        message: '派发询价单成功',
                        type: 'success'
                    });
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
                that.editSupplier = false;
            })


        },
        openSupplier() {
            if(this.$refs.detailTable.selection.length == 0){
                this.$notify.warning({
                    title: '提示',
                    message: "请先勾选询价单"
                });
            }else{
                this.editSupplier = true;
            }
        }

    },
    created() {
        this.onSearch();
        if(this.$store.state.userInfo.review){
            this.initStaffs();
        }

    },
}
</script>
<style>

</style>